module.exports = __webpack_public_path__ + "static/qualify_team-2c45a0b674aa0d5a7dfb18b2fed6963a.png";